import { CSSProperties, Children, Fragment, MouseEventHandler, ReactNode, forwardRef } from "react";
import { GenericComponentProps, makeStyles } from "../../../utils/genericComponentProps";

export type StackProps = GenericComponentProps & {
  direction?: CSSProperties["flexDirection"];
  alignItems?: CSSProperties["alignItems"];
  justifyContent?: CSSProperties["justifyContent"];
  spacing?: string | number;
  wrap?: boolean;
  onClick?: () => void;
  onMouseOver?: MouseEventHandler<HTMLDivElement>;

  style?: CSSProperties;

  divider?: ReactNode;
  children?: ReactNode;
};

export const Stack = forwardRef<HTMLDivElement, StackProps>((props, ref) => {
  const { children, divider, alignItems, justifyContent, spacing, style, direction = "row" } = props;
  const childrenArray = Children.toArray(children);

  const styles: CSSProperties = {
    ...makeStyles(props),
    display: "flex",
    flexDirection: direction,
    justifyContent,
    alignItems,
    gap: spacing,
    cursor: props.onClick ? "pointer" : "default",
    flexWrap: props.wrap ? "wrap" : undefined,
    ...style,
  };

  return (
    <div style={styles} onClick={props.onClick} className={props.className} ref={ref} onMouseOver={props.onMouseOver}>
      {divider
        ? childrenArray.map((child, index) => (
            <Fragment key={index}>
              {child}
              {index < childrenArray.length - 1 && divider}
            </Fragment>
          ))
        : children}
    </div>
  );
});
